import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Redirect } from "react-router"
import { Box, Paper, TextField } from "@mui/material"
import styles from './style.module.css'
import { Form, Formik } from "formik"
import { userSignIn, verifyOtp, clearMessage } from '../../appRedux/actions/Auth'
import * as yup from 'yup'
import { AppButton, DisplayMessage, Loader } from "../../components"

const validationSchema = yup.object({
  otp: yup.string().required('OTP is required').min(6, 'OTP should be min 6 characters').max(8, 'OTP should be max 6 characters'),
})

const OtpForm = (props) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (props.message) {
      setOpen(true)
      const clear = setTimeout(() => {
        props.clearMessage()
      }, 6000)
      return () => clearTimeout(clear)
    }
  }, [props.message])

  useEffect(() => {
    if (!open) {
      props.clearMessage()
    }
  }, [open])

  if (props.authUser) {
    return <Redirect to={{ pathname: '/dashboard' }} />
  }

  return (
    <div className={styles.container} >
      <Loader loading={props.loading} />
      {props.message && props.messageType && <DisplayMessage open={open} message={props.message} messageType={props.messageType} handleClose={() => setOpen(false)} />}
      <Box display="flex" flexWrap="wrap" justifyContent="space-around" alignContent="center" minHeight="94vh" height="100%">
        <Paper className={styles.otpFormContainer}>
          <div className={styles.root}>
            <Box className={styles.otpTextBox} p={1}>
              OTP Verification
            </Box>
          </div>
          <hr />
          <Box p={1}>
            <Formik
              initialValues={{
                otp: '',
              }}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                props.verifyOtp(values)
              }}
            >
              {(formik) => (
                <Form>
                  <Box m={2}>
                    <TextField
                      fullWidth
                      label="Enter OTP received on your registered email ID"
                      name="otp"
                      variant="standard"
                      onChange={formik.handleChange}
                      value={formik.values.otp}
                      error={formik.touched.otp && Boolean(formik.errors.otp)}
                      helperText={formik.touched.otp && formik.errors.otp}
                    />
                  </Box>
                  <Box display="flex" justifyContent="center" mt={5} mb={2}>
                    <AppButton type="submit" text="Verify" />
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Paper>
      </Box>
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authUser, verifiedEmail, message, messageType, loading } = auth
  return { authUser, verifiedEmail, message, messageType, loading }
}

const mapDispatchToProps = dispatch => ({
  userSignIn: payload => dispatch(userSignIn(payload)),
  verifyOtp: payload => dispatch(verifyOtp(payload)),
  clearMessage: () => dispatch(clearMessage())
})

export default connect(mapStateToProps, mapDispatchToProps)(OtpForm)